import { graphql } from "babel-plugin-relay/macro";
import React from "react";
import { createFragmentContainer } from "react-relay";
import { DropdownElement_element$data } from "../../__generated__/DropdownElement_element.graphql";
import { DropdownElement_screener$data } from "../../__generated__/DropdownElement_screener.graphql";
import { CommonElementProps } from "./Element";
import { ElementBase } from "./index";

type Props = {
  element: DropdownElement_element$data;
  screener: DropdownElement_screener$data;
} & CommonElementProps;
const DropdownElement: React.FC<Props> = props => <ElementBase {...props} />;

export default createFragmentContainer(DropdownElement, {
  element: graphql`
    fragment DropdownElement_element on ElementNode {
      ...ElementBase_element
    }
  `,
  screener: graphql`
    fragment DropdownElement_screener on ScreenerNode {
      ...ElementBase_screener
    }
  `,
});
